import PageNotAuthorizedContainer from './PageNotAuthorizedContainer';

export default PageNotAuthorizedContainer;
